









































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TextField from '@/reusable/Form/TextField.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import SwitchForm from '@/reusable/Form/SwitchForm.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import HandleErrors from '@/config/handleErrors';
import moment from 'moment';
import {
  emitFormChangeEvent,
  formErrors,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
// import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import FormFieldContainerFacturacion from '@/pantallas/Facturacion/FormFieldContainerFacturacion.vue';
import { Snotify } from '@/snotify/Snotify';
import { EstadoEntidad } from '../../config/enums';
import ValidaRut from '@/config/validaRut';
import { LoadingService } from '@/services/loadingService';

import { fetchGiro } from '@/reusable/Giro/fetchGiro';
import { Giro } from '@/reusable/Giro/Giro';
import { Factura } from '@/pantallas/Facturacion/fetchFacturaciones';
import { ValueFormatterParams } from 'ag-grid-community';

@Component({
  components: {
    TextField,
    // FormFieldsContainer,
    FormFieldContainerFacturacion,
  },
})
export default class FacturaForm extends Vue {
  @Prop() facturaSeleccionada: Factura;
  @Prop() tipoDocumento: string;

  isFormValid: boolean = false;
  readonly $snotify: Snotify;
  readonly controller: string = 'Proveedor';
  readonly loadingService = new LoadingService();
  axios: AxiosVue = new AxiosVue(ServicioProxy.Comercial);

  mensajeEstado: string = '';
  modoVer: boolean = true;
  esTipoDocumento: string;
  vr: ValidaRut = new ValidaRut();

  formFields: FormFieldDefMap = {
    folio: {
      label: 'Folio',
      id: 'folio',
      value: '',
    },
    comuna: {
      label: 'Comuna',
      id: 'comuna',
      value: '',
    },
    ciudad: {
      label: 'Ciudad',
      id: 'ciudad',
      value: '',
    },
    nombreRS: {
      label: 'Nombre o Razón Social',
      id: 'nombreRS',
      value: '',
    },
    rut: {
      label: 'Rut',
      id: 'rut',
      value: '',
    },
    direccion: {
      label: 'Dirección',
      id: 'direccion',
      value: '',
    },
    giro: {
      label: 'Giro',
      id: 'giro',
      value: '',
    },
    fechaEmision: {
      label: 'Fecha Emisión',
      id: 'fechaEmision',
      value: '',
      // valueFormatter: this.formatFecha,
    },
    condicionPago: {
      label: 'Condición de Pago',
      id: 'condicionPago',
      value: '',
    },
  };

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
    const self = this;
    let r = this.vr;

    this.handleFormChange(this.formFields);
    this.handlecalibracionSeleccionadaChange();
  }

  @Watch('facturaSeleccionada', { deep: true })
  handlecalibracionSeleccionadaChange() {
    if (!this.facturaSeleccionada) {
      return;
    }
    this.formFields.comuna.value = this.facturaSeleccionada.comunaReceptor;
    this.formFields.ciudad.value = this.facturaSeleccionada.ciudadReceptor;
    this.formFields.folio.value = this.facturaSeleccionada.folio;
    this.formFields.nombreRS.value = this.facturaSeleccionada.nombreReceptor;
    this.formFields.rut.value = this.facturaSeleccionada.rutReceptor;
    this.formFields.direccion.value = this.facturaSeleccionada.direccionReceptor;
    this.formFields.giro.value = this.facturaSeleccionada.giroReceptor;
    this.formFields.fechaEmision.value = this.facturaSeleccionada.fechaEmisionText;
    this.formFields.condicionPago.value = this.facturaSeleccionada.condicionDePago;
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {}

  formatFecha(params: ValueFormatterParams) {
    return params.value.format('DD/MM/YYYY');
  }

  get tituloDocumento() {
    if (this.tipoDocumento === 'FACTURA ELECTRONICA') {
      this.esTipoDocumento = 'Factura';
    } else if (this.tipoDocumento === 'NOTA DE CREDITO ELECTRONICA')
      this.esTipoDocumento = 'Nota de Crédito';
    return this.esTipoDocumento;
  }
}
